import { __assign } from "tslib";
/** An editor content viewer for deviations description */
import React from 'react';
import BaseViewer from './Base';
import deviationTheme from '../Themes/Viewer/deviation.scss';
var DeviationViewer = function (props) {
    return (React.createElement("div", { className: 'da-editor-comments' },
        React.createElement(BaseViewer, __assign({ theme: deviationTheme, showMediaAlwaysSmall: true, fixedParagraph: false }, props))));
};
export default DeviationViewer;
//# sourceMappingURL=Deviation.js.map